import {
	LOAD_RESTAURANTS_SUCCESS,
	CLEAR_RESTAURANTS
 } from '../../actions/types';

const INITIAL_STATE = {
	content: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case LOAD_RESTAURANTS_SUCCESS:
			return action.payload;
		case CLEAR_RESTAURANTS:
			return INITIAL_STATE;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/RestaurantsReducer.js